import { PACKAGES } from "@/data/catalog";
import { Check } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";

export default function PackagesSection() {
    const { t } = useT();
    return (
        <section
            id="forfaits"
            data-testid="packages-section"
            className="py-20 md:py-32 relative scroll-mt-24"
        >
            {/* Turquoise band background */}
            <div className="absolute inset-x-0 top-0 bottom-0 bg-gradient-to-b from-[#3D8C95]/8 via-[#3D8C95]/4 to-transparent" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 mb-14">
                    <div className="lg:col-span-5">
                        <div className="text-xs tracking-[0.3em] uppercase text-[#3D8C95] mb-4">
                            {t("pkg.eyebrow")}
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl font-light text-[#2C2A29] tracking-tight leading-tight">
                            {t("pkg.title1")}{" "}
                            <span className="italic text-[#3D8C95]">{t("pkg.title2")}</span>.
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-[#6E6862] leading-relaxed text-base md:text-lg">
                            {t("pkg.desc")}
                        </p>
                    </div>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {PACKAGES.map((p, i) => {
                        const featured = i === 2;
                        return (
                            <div
                                key={p.id}
                                data-testid={`package-card-${p.id}`}
                                className={`relative rounded-3xl p-7 transition-all duration-500 hover:-translate-y-1 ${
                                    featured
                                        ? "bg-[#2C2A29] text-white shadow-[0_25px_60px_rgba(44,42,41,0.25)]"
                                        : "bg-white border border-[#E8E2D9] text-[#2C2A29] shadow-[0_8px_30px_rgba(44,42,41,0.04)]"
                                }`}
                            >
                                {featured && (
                                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-[#3D8C95] text-white text-[10px] uppercase tracking-widest">
                                        {t("pkg.recommended")}
                                    </div>
                                )}
                                <div className={`text-xs uppercase tracking-[0.2em] ${featured ? "text-[#E07A5F]" : "text-[#3D8C95]"} mb-3`}>
                                    {t("pkg.label")}
                                </div>
                                <div className="font-display text-5xl md:text-6xl font-light leading-none">
                                    {p.count}
                                </div>
                                <div className={`text-sm mt-1 ${featured ? "text-white/70" : "text-[#6E6862]"}`}>
                                    {t("pkg.massages")}
                                </div>

                                <div className="mt-6 pt-6 border-t border-[#E8E2D9]/30 flex items-baseline gap-1">
                                    <span className="font-display text-3xl">{p.price}</span>
                                    <span className={`text-sm ${featured ? "text-white/70" : "text-[#6E6862]"}`}>$</span>
                                </div>
                                <div className={`text-xs mt-1 ${featured ? "text-[#3D8C95]" : "text-[#3D8C95]"}`}>
                                    {t("pkg.save")} {p.save}$
                                </div>

                                <ul className="mt-6 space-y-2">
                                    <li className="flex items-start gap-2 text-xs">
                                        <Check size={14} className={featured ? "text-[#E07A5F]" : "text-[#3D8C95]"} />
                                        <span className={featured ? "text-white/80" : "text-[#6E6862]"}>
                                            {t("pkg.feat1")}
                                        </span>
                                    </li>
                                    <li className="flex items-start gap-2 text-xs">
                                        <Check size={14} className={featured ? "text-[#E07A5F]" : "text-[#3D8C95]"} />
                                        <span className={featured ? "text-white/80" : "text-[#6E6862]"}>
                                            {t("pkg.feat2")}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
